import NoOccasionalGuests from '@spa/shared/svg/no-occasional-guests';
import NoPets from '@spa/shared/svg/no-pets';
import NoProfessionals from '@spa/shared/svg/no-professionals';
import NoSmoking from '@spa/shared/svg/no-smoking';
import DomesticStudent from '@spa/shared/svg/domestic-student';
import InternationalStudent from '@spa/shared/svg/international-student';
import Female from '@spa/shared/svg/female';
import Male from '@spa/shared/svg/male';

export const PROPERTY_RULES = {
  'overnight-guests-allowed': {
    Component: NoOccasionalGuests,
    translation: 'property_rules.guests_not_allowed'
  },
  'pets-allowed': {
    Component: NoPets,
    translation: 'property_rules.pets_not_allowed'
  },
  'professionals-allowed': {
    Component: NoProfessionals,
    translation: 'property_rules.professionals_not_allowed'
  },
  'postgraduate-students-allowed': {
    Component: NoProfessionals, //TODO: maybe implement a different icon
    translation: 'property_rules.postgraduate_students_not_allowed'
  },
  'undergraduate-students-allowed': {
    Component: NoProfessionals, //TODO: maybe implement a different icon
    translation: 'property_rules.undergraduate_students_not_allowed'
  },
  'smoking-allowed': {
    Component: NoSmoking,
    translation: 'property_rules.smoking_not_allowed'
  },
  'domestic-students-allowed': {
    Component: InternationalStudent,
    translation: 'property_rules.international_students_only'
  },
  'international-students-allowed': {
    Component: DomesticStudent,
    translation: 'property_rules.domestic_students_only'
  },
  'males-allowed': {
    Component: Female,
    translation: 'property_rules.female_only'
  },
  'females-allowed': {
    Component: Male,
    translation: 'property_rules.male_only'
  }
};
